import { FunctionComponent, useEffect } from 'react';
import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { useForm } from '@/components/Form/utils';
import { Title } from 'UI';
import { Box } from 'vopay';
import { useConvertMyTemplateFormFields, type ConvertMyTemplateFormValues } from './useConvertMyTemplateFormFields';

const { Card } = vp;

type ConvertMyTemplateFormProps = {
  onSubmit: (values: ConvertMyTemplateFormValues) => void;
  onValidate: (isValid: boolean) => void;
  isReviewing?: boolean;
  defaultValues?: Partial<ConvertMyTemplateFormValues>;
};

type FC = FunctionComponent<ConvertMyTemplateFormProps>;

const ConvertMyTemplateFormValues: FC = ({ onSubmit, onValidate, defaultValues = {}, isReviewing = false }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.FileUploadDrawer.ConvertTemplate' });

  const { uploadFile } = useConvertMyTemplateFormFields();

  const initialValues: ConvertMyTemplateFormValues = {
    Service: 'Debit',
    FileBase64: '',
    FileName: '',
    ...defaultValues,
  };

  const { renderFormElements, ctx } = useForm<ConvertMyTemplateFormValues>({
    initialValues,
    config: uploadFile,
    isReviewing,
    onSubmit: (values, ctx) => {
      onSubmit({
        ...values,
        FileName: ctx.values.FileName,
        FileBase64: ctx.values.FileBase64,
      });
    },
  });

  useEffect(() => {
    onValidate(ctx.isValid);
  }, [ctx]);

  return (
    <form onSubmit={ctx.handleSubmit} id="fileUploadForm">
      <Box flx="col" gap="md">
        <Card>
          <Box flx="col" gap="md">
            <Title level="5">{t('uploadFile')}</Title>
            {renderFormElements({ config: uploadFile })}
          </Box>
        </Card>
      </Box>
    </form>
  );
};

export default ConvertMyTemplateFormValues;
